import type { ComposeViewState } from "../store/schema/ComposeViewState";
import { type UIEnabledState } from "../store/schema/UIEnabledState";
import { WaitOnSendEvaluation } from "owa-editor-augloopdlp-utils/lib/store/schema/DLPWaitOnSendViewState";

function isEvaluatingDLP(viewState: ComposeViewState): boolean {
    return (viewState.dlpAnnotationViewState?.waitOnSendViewState?.waitOnSendEvaluation ===
        WaitOnSendEvaluation.Started);
}

export function shouldDisableCompose(viewState: ComposeViewState): boolean {
    return (viewState.uiEnabledState === 2 ||
        viewState.isInAuthErrorState ||
        isEvaluatingDLP(viewState));
}
